import useGameParams from '~/client/components/Game/hooks/useGameParams';
import useFeatures from '~/client/hooks/feature/useFeatures';
import useLanguage from '~/client/hooks/useLanguage';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useSite from '~/client/hooks/useSite';
import { useGameQuery } from '~/shared/graphql/game/GameQuery.generated';
import getGameQueryVariables from '~/shared/graphql/game/helpers/getGameQueryVariables';

const useGameProps = () => {
  const { site } = useSite();
  const { code } = useLanguage();
  const { handle = '', categoryHandle = '' } = useGameParams();
  const currentUser = useCurrentUser();
  const featureFlags = useFeatures();
  const variables = getGameQueryVariables({
    site,
    featureFlags,
    currentUser,
    handle,
    locale: code,
    category: categoryHandle,
  });
  const { data } = useGameQuery({ variables });
  const game = data?.casino?.games?.edges?.[0]?.node;
  const description = data?.content?.pages?.edges?.[0]?.node;
  return { game, description };
};

export default useGameProps;
